export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_03.f19c61b7.jpg";